import { render, staticRenderFns } from "./AIDataPack.vue?vue&type=template&id=01236d06&scoped=true"
import script from "./AIDataPack.vue?vue&type=script&lang=js"
export * from "./AIDataPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01236d06",
  null
  
)

export default component.exports